<template>
    <div class="autocomplete-select" ref="autocomplete">
      <input
        type="text"
        :placeholder="placeholder"
        v-model="query"
        @focus="showDropdown = true"
        @input="handleInput"
        @keydown.down="handleDown"
        @keydown.up="handleUp"
        @keydown.enter.prevent="selectActive"
        class="form-control"
      />
      <ul v-if="showDropdown && filteredOptions.length" class="options-list">
        <li
          v-for="(option, index) in filteredOptions"
          :key="option.value"
          :class="{ active: index === activeIndex }"
          @mousedown.prevent="selectOption(option)"
        >
          {{ option.label }}
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    name: "AutocompleteSelect",
    props: {
      modelValue: {
        type: [String, Number, null],
        default: null
      },
      options: {
        type: Array,
        required: true
      },
      placeholder: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        query: "",
        showDropdown: false,
        activeIndex: -1
      };
    },
    computed: {
      filteredOptions() {
        if (!this.query) {
          return this.options;
        }
        const q = this.query.toLowerCase();
        return this.options.filter((option) =>
          option.label.toLowerCase().includes(q)
        );
      }
    },
    watch: {
      // Si el valor externo cambia, actualizamos la query con la etiqueta correspondiente
      modelValue: {
        handler(newVal) {
          const selected = this.options.find((opt) => opt.value === newVal);
          this.query = selected ? selected.label : "";
        },
        immediate: true
      }
    },
    methods: {
      handleInput() {
        this.showDropdown = true;
        this.activeIndex = -1;
      },
      selectOption(option) {
        this.$emit("update:modelValue", option.value);
        this.query = option.label;
        this.showDropdown = false;
      },
      handleDown() {
        if (!this.showDropdown) {
          this.showDropdown = true;
          return;
        }
        if (this.activeIndex < this.filteredOptions.length - 1) {
          this.activeIndex++;
        }
      },
      handleUp() {
        if (!this.showDropdown) {
          this.showDropdown = true;
          return;
        }
        if (this.activeIndex > 0) {
          this.activeIndex--;
        }
      },
      selectActive() {
        if (
          this.activeIndex >= 0 &&
          this.activeIndex < this.filteredOptions.length
        ) {
          this.selectOption(this.filteredOptions[this.activeIndex]);
        }
      },
      handleClickOutside(event) {
        if (!this.$refs.autocomplete.contains(event.target)) {
          this.showDropdown = false;
        }
      }
    },
    mounted() {
      document.addEventListener("click", this.handleClickOutside);
    },
    beforeUnmount() {
      document.removeEventListener("click", this.handleClickOutside);
    }
  };
  </script>
  
  <style scoped>
  .autocomplete-select {
    position: relative;
  }
  .autocomplete-select input {
    width: 100%;
    padding: 0.375rem 0.75rem;
    border: 1px solid #ced4da;
    border-radius: 0.375rem;
  }
  .options-list {
    position: absolute;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    margin: 0;
    padding: 0;
    list-style: none;
    border: 1px solid #ced4da;
    border-top: none;
    background-color: #fff;
    z-index: 1000;
  }
  .options-list li {
    padding: 0.375rem 0.75rem;
    cursor: pointer;
  }
  .options-list li.active,
  .options-list li:hover {
    background-color: #007bff;
    color: #fff;
  }
  </style>
  